import {
  compareAbilities,
  compareBothTypes,
  compareGeneration,
  compareHeight,
  compareTotalStats,
  compareWeight,
  comparePokemonNames,
  returnArrow,
} from '../utils/compares';
import {
  getPokemonFromStorage,
  getPokemonFromStorageCries,
  getPokemonFromStorageEmoji,
} from './getPokemonFromStorage';

export function getPokemonInfoFromStorage() {
  const randomPokemon = getPokemonFromStorage();

  const storedData = JSON.parse(localStorage.getItem('pokemonInfoList'));
  if (Array.isArray(storedData)) {
    const pokemonInfoList = [];
    storedData.forEach((pokemon) => {
      const {
        gen,
        type1,
        type2,
        weight,
        height,
        total_stats,
        name,
        id,
        sprite,
        ability1,
        ability2,
        ability3,
      } = pokemon;

      pokemonInfoList.push({
        gen,
        type1,
        type2,
        weight,
        height,
        total_stats,
        name,
        id,
        sprite,
        ability1,
        ability2,
        ability3,
        colorGeneration: compareGeneration(gen, randomPokemon.gen),
        colorTypes: compareBothTypes(type1, type2, randomPokemon.type1, randomPokemon.type2),
        colorAbilities: compareAbilities(
          ability1,
          ability2,
          ability3,
          randomPokemon.ability1,
          randomPokemon.ability2,
          randomPokemon.ability3,
        ),
        colorWeight: compareWeight(weight, randomPokemon.weight),
        colorHeight: compareHeight(height, randomPokemon.height),
        colorTotalStats: compareTotalStats(total_stats, randomPokemon.total_stats),
        arrowWeight: returnArrow(weight, randomPokemon.weight),
        arrowHeight: returnArrow(height, randomPokemon.height),
        arrowTotalStats: returnArrow(total_stats, randomPokemon.total_stats),
      });
    });

    // Eliminar duplicados en pokemonInfoList
    const uniquePokemonInfoList = pokemonInfoList.filter(
      (pokemon, index, self) => index
        === self.findIndex(
          (p) => p.id === pokemon.id && p.name === pokemon.name && p.gen === pokemon.gen,
        ),
    );

    return uniquePokemonInfoList;
  }
  return null;
}

export function getPokemonInfoFromStorageCries() {
  const randomPokemon = getPokemonFromStorageCries();
  const storedData = JSON.parse(localStorage.getItem('pokemonInfoListCries'));
  if (Array.isArray(storedData)) {
    const pokemonInfoList = [];
    storedData.forEach((pokemon) => {
      const { name, id, sprite } = pokemon;

      pokemonInfoList.push({
        name,
        id,
        sprite,

        colorName: comparePokemonNames(name, randomPokemon.name),
      });
    });

    // Eliminar duplicados en pokemonInfoList
    const uniquePokemonInfoList = pokemonInfoList.filter(
      (pokemon, index, self) => index
        === self.findIndex(
          (p) => p.id === pokemon.id && p.name === pokemon.name && p.gen === pokemon.gen,
        ),
    );

    return uniquePokemonInfoList;
  }
  return null;
}

export function getPokemonInfoFromStorageEmoji() {
  const randomPokemon = getPokemonFromStorageEmoji();
  const storedData = JSON.parse(localStorage.getItem('pokemonInfoListEmoji'));
  if (Array.isArray(storedData)) {
    const pokemonInfoList = [];
    storedData.forEach((pokemon) => {
      const { name, id, sprite } = pokemon;

      pokemonInfoList.push({
        name,
        id,
        sprite,
        colorName: comparePokemonNames(name, randomPokemon.name),
      });
    });

    // Eliminar duplicados en pokemonInfoList
    const uniquePokemonInfoList = pokemonInfoList.filter(
      (pokemon, index, self) => index
        === self.findIndex(
          (p) => p.id === pokemon.id && p.name === pokemon.name && p.gen === pokemon.gen,
        ),
    );

    return uniquePokemonInfoList;
  }
  return null;
}
